    <!-- Required Filters -->
    <div class="ns-filter-bar">
       <mat-form-field class="ns-mat-filter">
        <mat-label>Company</mat-label>
        <mat-select [(ngModel)]="selectedCompany" (ngModelChange)="onCompanyChange()">
          <mat-option value="" disabled> Select Company </mat-option>
          @for (company of companyList; track company.company_id) {
            <mat-option [value]="company.company_id">
              {{ company.company_code }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="ns-mat-filter">
        <mat-label>Plant</mat-label>
        <mat-select [(ngModel)]="selectedPlant" (ngModelChange)="onPlantChange()">
          <mat-option value="" disabled> Select Plant </mat-option>
          @for (plant of currentCompany?.plantList; track plant.plant_id) {
            <mat-option [value]="plant.plant_id">
              {{ plant.plant_name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      

      <p *ngIf="!shopDetailFiltersComplete" class="ns-filter-hint" aria-live="polite">
        All three filters are required to generate shop data.
      </p>
    </div>

    <div class="map-explorer" *ngIf="shopDetailFiltersComplete">
      <h3 class="detail-title map-explorer__title">
        {{
          (currentCompany?.company_code || 'Company') +
          ' - ' +
          (currentPlant?.plant_name || 'Plant') +
          ' - Woodstock Summary'
        }}
      </h3>
      

      <!-- Map panel with real PNG background + positioned NAMC pins -->
      <div class="map-column">
      <div class="map-panel-shop" role="group" aria-label="North America NAMC deployment map">
        

        <button *ngFor="let pin of deploymentMapPins; trackBy: trackByMapCode"
          class="namc-pin"
          [ngClass]="[
            'namc-pin--' + pin.status,
            isMapNamcSelected(pin.code) ? 'namc-pin--active' : ''
          ]"
          type="button"
          [style.left]="pin.left"
          [style.top]="pin.top"
          [style.--label-nudge]="pin.labelNudge"
          [style.--leader-len]="pin.leaderLen"
          [attr.aria-label]="getMapPinAriaLabel(pin)"
          [attr.aria-pressed]="isMapNamcSelected(pin.code)"
          (click)="selectMapNamc(pin)">
          <span class="pin-dot" aria-hidden="true"></span>
          <span class="pin-leader"
            [ngClass]="'pin-leader--' + pin.labelDirection"
            aria-hidden="true"></span>
          <span class="pin-label"
            [ngClass]="'pin-label--' + pin.labelDirection">
            {{ pin.code }} <br/> {{ pin.value }}{{pin.value != 'N/A' ? '%' : ''}}</span>
            
        </button>

        <div class="map-bottom-legend">
          <span><i class="map-key-dot map-key-dot--enabled"></i> Stamping</span>
          <span><i class="map-key-dot map-key-dot--progress"></i> Weld</span>
          <span><i class="map-key-dot map-key-dot--paint"></i> Paint</span>
          <span><i class="map-key-dot map-key-dot--assembly"></i> Assembly</span>
        </div>
      </div>

      <fieldset class="map-location-list" aria-label="Select a shop on the map">
        <button *ngFor="let pin of deploymentMapPins; trackBy: trackByMapCode"
          type="button" class="map-location-option"
          [ngClass]="'map-location-option--' + pin.status"
          [attr.aria-label]="getMapPinAriaLabel(pin)"
          [attr.aria-pressed]="isMapNamcSelected(pin.code)"
          (click)="selectMapNamc(pin)">
          <span>{{ pin.code }}</span>
          <span>{{ pin.value }}{{ pin.value != 'N/A' ? '%' : '' }}</span>
        </button>
      </fieldset>
      </div>

      <!-- Deployment Detail Panel -->
      <div class="deployment-detail">
        <ng-container *ngIf="selectedPin">
          <div class="detail-stats">
            <article class="kpi-card">
              <span class="kpi-label">Shop Connectivity</span>
              <div class="conn-kpi-body conn-kpi-body--inline">
                  <div class="conn-kpi-icon" [ngClass]="connectivityIconClass"><i class="pi pi-wifi"></i></div>
                  <div class="kpi-value">{{ selectedPinConnectivityLabel }}</div>
              </div>
              <div class="kpi-delta delta-font-small">PDM + Equipment / Total Planned</div>
            </article>

            <article class="kpi-card">
              <span class="kpi-label">Equipment Connectivity</span>
              <div class="conn-kpi-body conn-kpi-body--inline">
                  <div class="conn-kpi-icon conn-kpi-icon--teal"><i class="pi pi-server"></i></div>
                  <div class="kpi-value">                    
                    <span class="">{{ (selectedPinDashboard?.equipmentConnected ?? 0) | number }}</span>/<span class="kpi-value-one">{{ (selectedPinDashboard?.equipmentPlanned ?? 0) | number }}</span>
                  </div>
              </div>
              <div class="kpi-delta delta-font-small">Equipment Connected / Equipment Planned</div>
            </article>
          </div>
          <div class="detail-stats detail-stats--pdm" style="margin-top: 8px">
            <div class="ns-pdm-wrap">
              <table class="data-table ns-pdm-table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="numeric">PLANNED</th>
                    <th class="numeric">CONNECTED</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>PdM<br>Connectivity</strong></td>
                    <td class="numeric">{{ selectedPinDashboard?.pdm?.planned ?? 0 }}</td>
                    <td class="numeric">{{ selectedPinDashboard?.pdm?.connected ?? 0 }}</td>
                    <td>
                      <div class="ns-status-bar-wrap">
                        <div class="ns-status-bar-track">
                          <div [style.height]="'100%'" [style.width.%]="selectedPinStatusPct" style="background:linear-gradient(90deg,#c62828,#ef5350);border-radius:4px;"></div>
                        </div>
                        <span class="ns-status-pct">{{ selectedPinStatusPct }}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </ng-container>
        <ng-template #detailEmpty>
          <div class="detail-title">Deployment Status</div>
          <p class="muted">{{'Select a NAMC on the map to view its deployment metrics and shop enablement status.' }}</p>
        </ng-template>
      </div> 

    </div>

    <!-- Empty state: no filters selected -->
    <div *ngIf="!shopDetailFiltersComplete" class="ns-empty-state">
      <div class="ns-empty-icon" aria-hidden="true">🏭</div>
      <h3>Select a NAMC, Plant, and Shop to view deployment data</h3>
      <p>Use the filters above to drill into a specific shop's deployment progress, equipment summary, open actions, and deployment timeline.</p>
    </div>

    
